import React from 'react'
import './live.css'
export default function Live() {
  return <div class="loader">Live</div>;
}
